// SEO Constants - Single source of truth for all SEO-related data

// Site Configuration
export const SITE = {
  url: "https://anotherwhy.com",
  name: "anotherwhy",
  title: "anotherwhy",
  description: "anotherwhy is a software company for everyday problems. Home of zero, an offline expense tracker and finance app for Android and iOS.",
  logo: "/2.svg",
  locale: "en_IN",
  twitter: "@anikiinme",
} as const;

// Organization Details (for JSON-LD)
export const ORGANIZATION = {
  name: "Anotherwhy Technologies",
  alternateName: "anotherwhy",
  foundingDate: "2020",
  founder: "Bandana Bhuin",
  email: "info@anotherwhy.com",
  address: {
    locality: "Durgapur",
    region: "West Bengal",
    postalCode: "713205",
    country: "IN",
  },
  social: {
    github: "https://github.com/indranilbhuin",
    linkedin: "https://linkedin.com/company/anotherwhy/",
  },
} as const;

// Page-specific SEO metadata
export const PAGE_META = {
  home: {
    title: SITE.title,
    description: SITE.description,
  },
  products: {
    title: "Products",
    description: "Explore products by anotherwhy. zero, an offline expense tracker, and more useful software for everyday problems.",
  },
  story: {
    title: "Our Story",
    description: "The journey of anotherwhy, one question at a time. 150+ blogs and the 'why' that never stopped.",
  },
  connect: {
    title: "Connect",
    description: "Get in touch with anotherwhy. Find us on GitHub, LinkedIn, or send an email for collaborations and inquiries.",
  },
} as const;

// Helper to get full URL (for pages and assets)
export function getFullUrl(path: string): string {
  if (path.startsWith("http")) return path;
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${SITE.url}${normalizedPath}`;
}

// Alias for semantic clarity when used for images
export const getImageUrl = getFullUrl;
